/**
 * pdf.js 5 calls Map.prototype.getOrInsert / getOrInsertComputed (Map upsert).
 * iOS Safari / Simulator WebKit do not implement these; Chrome desktop does.
 * Must run before getDocument / page.render() and before the pdf.js worker starts.
 */

declare global {
  interface Map<K, V> {
    getOrInsert(key: K, value: V): V;
    getOrInsertComputed(key: K, callbackfn: (key: K) => V): V;
  }
}

export function installMapUpsertPolyfill(): void {
  const proto = Map.prototype;

  if (typeof proto.getOrInsert !== 'function') {
    proto.getOrInsert = function <K, V>(this: Map<K, V>, key: K, value: V): V {
      if (this.has(key)) {
        return this.get(key) as V;
      }
      this.set(key, value);
      return value;
    };
  }

  if (typeof proto.getOrInsertComputed !== 'function') {
    proto.getOrInsertComputed = function <K, V>(
      this: Map<K, V>,
      key: K,
      callbackfn: (key: K) => V,
    ): V {
      if (this.has(key)) {
        return this.get(key) as V;
      }
      const value = callbackfn(key);
      this.set(key, value);
      return value;
    };
  }
}

installMapUpsertPolyfill();
